/**
 * Count-up animation for CGF Stats numbers (.js-countup).
 * The real value is rendered server-side, so no-JS visitors and users with
 * prefers-reduced-motion always see the final number.
 */
const DURATION = 2000;

function animate(el) {
    const text = el.textContent;
    const match = text.match(/[\d,]+/);
    if (!match) {
        return;
    }
    const target = parseInt(match[0].replace(/,/g, ''), 10);
    const prefix = text.slice(0, match.index);
    const suffix = text.slice(match.index + match[0].length);
    const hasThousands = match[0].includes(',');
    let start = null;

    const step = (timestamp) => {
        if (start === null) {
            start = timestamp;
        }
        const progress = Math.min((timestamp - start) / DURATION, 1);
        const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
        let value = Math.round(target * eased);
        if (hasThousands) {
            value = value.toLocaleString('en-GB');
        }
        el.textContent = prefix + value + suffix;
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };

    window.requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', () => {
    const els = document.querySelectorAll('.js-countup');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!els.length || reduced || !('IntersectionObserver' in window)) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                animate(entry.target);
            }
        });
    }, { threshold: 0.4 });

    els.forEach((el) => observer.observe(el));
});
